<div [className]="theme?.root + ' bg-no-repeat bg-center bg-cover'" [style]="theme?.bgImage">
  <div class="container {{ theme.container }}">
    @if (topContent) {
      <div
        class="wysiwyg py-v-spacing max-w-container mx-auto bundle__top-content" [class.sm:px-v-spacing]="theme.container.length === 0"
        [innerHtml]="topContent"
      ></div>
    }
    <div class="mx-auto w-fit" [class.sm:px-v-spacing]="theme.container.length === 0">
      <!-- Desktop View -->
      <div
        id="bundle"
        [attr.data-coupon-scroll-target]="hasPricedBundle ? couponScrollTarget : null"
        class="auto-cols-min  bundle-container md:grid grid-cols-1 justify-items-center desktop-grid {{bundleContainerStyles}}"
        >
        <div class="bundle-xl-space {{bundleContainerStylesColSpan}}"></div>
        @for (b of bundles; track b; let last = $last; let index = $index) {
          <div
            class="pt-v-spacing  w-full flex flex-col bundle-product"
            [ngClass]="bundles.length > 2 ? { 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 } : { 'basic-column': index === 0, 'premium-column': index === 1}"
            >
            @if (isAceDesign) {
              @if (b.topContent) {
                <tier-badge [topContent]="b.topContent" [topContentStyles]="b.topContentStyles"
                [topBackgroundColor]="b.topBackgroundColor" [topTextColor]="b.topTextColor"></tier-badge>
              } @else {
                <span class="h-[38px]"></span>
              }
            } @else {
              <div
                class="rounded-t-md w-full bundle-top"
                [ngClass]="b.topContent ? 'bg-vis-teal-2 text-vis-reverse' + ' border-t border-r border-l' : ''"
                >
                <span
                  class="text-sm font-extrabold rounded-t-md inline-block uppercase py-2 px-6 w-full"
                  [ngClass]="b.topContent ? 'bg-vis-teal-2 text-vis-reverse' : ''"
                  >{{ b.topContent }}</span
                  >
                </div>
              }
              <div
                class="w-full flex flex-col h-full bg-white text-vis-regular border-top-bundle"
				[ngClass]="isAceDesign
				  ? 'shadow-card rounded-ace-mode'
				  : (b.topContent ? 'rounded-b-md-top rounded-t-none' : 'rounded-b-md-top rounded-t-md-top')"
                >
                <div class="wysiwyg p-v-spacing xl:pb-6 pb-4" [innerHTML]="b.principalContent"></div>
                <div class="flex flex-col h-full justify-end">
                  <div class="w-full pt-0 xl:pb-4 pb-2 p-v-spacing">
                    <div [class]="b.savePercentage ? '' : 'invisible'" class="text-xs font-bold text-vis-brand-2">
                      SAVE @if (b.discountType === 'PERCENT') {
                      <span>{{ b.savePercentage }}%</span>
                      }@if (b.discountType === 'FLAT') {
                      <span>${{ b.maxPrice - b.originalPrice }}</span>
                    }
                  </div>
                  <div class="flex flex-col">
                    <div class="flex">
                      @if (b.maxPrice && b.savePercentage) {
                        <span
                          class="text-lg font-extrabold price-cross-color line-through decoration-vis-dark text-vis-regular mr-1"
                          >${{ b.maxPrice | customNumber : '1.0-0' }}</span
                          >
                        }
                        @if (b.originalPrice) {
                          <span #bundlePrice class="text-lg font-extrabold text-vis-teal">
                            ${{ b.originalPrice | customNumber : '1.0-0' }}</span
                            >
                          }
                        </div>
                        @if (couponApplied) {
                          <span
                            class="coupon-applied justify-center text-[13px] font-bold text-vis-brand-2 rounded-[30px] py-[7px] px-[15px] bg-[#d9e7f2] w-[50%] xs:w-[34%] sm:w-[28%] md:w-3/4 lg:w-[80%] xl:w-2/3"
                            >Coupon Applied!</span
                            >
                          }
                        </div>
                      </div>
                      @if (b.originalPrice >= bnplThreshold) {
                        <div class="pb-4 text-xs text-vis-grey-4 px-v-spacing">
                          <span
                            >As low as ${{ b.affirmPrice }}/mo with
                            <img class="inline-block affirm-img" src="https://xgrit-ecom.imgix.net/ace/affirm-logo.svg" alt="Affirm Logo" />
                            †, or 4 interest-free payments of ${{ b.klarnaPrice }} with
                            <img class="inline-block klarna-img" src="https://xgrit-ecom.imgix.net/ace/klarna-logo.svg" alt="Klarna Logo" />
                            ††
                          </span>
                        </div>
                      }
                      <div class="text-center text-vis-teal-2 text-md font-bold mt-8 mb-4"><a href="javascript:void(0)" (click)="scrollToPricingTable()" class="underline decoration-dotted underline-offset-8">View Package Details</a></div>
                      <div class="w-full pt-0 p-v-spacing items-center">
                        <div class="w-full xs:mr-v-spacing lg:mr-0 xl:mr-v-spacing">
                          <vision-button [data]="getButtonData(b)" [className]="'basic-cta_desktop'"></vision-button>
                        </div>
                        <div
                          class="w-full mt-2 text-center text-xs text-vis-subtle"
                          [class.cursor-pointer]="b.product[0]?.showGuaranteeText"
                          (click)="b.product[0]?.showGuaranteeText && activateModal()"
                          >
                          @if (b.product[0] && !suppressGuarantee(b.product[0])) {
                            <span class="inline-block"
                              >{{ b.product[0].showGuaranteeText ? guaranteeText : '' }}</span
                              >
                            }
                          </div>
                        </div>
                        @if (b.bottomContent) {
                          <div class="wysiwyg p-v-spacing w-full mt-4" [innerHTML]="b.bottomContent"></div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
              <!--end bundle-->
              <div class="pricing-table-container mt-12" id="pricing-table-container">
                @if (bundlePricingItems) {
                  <div class="pricing-table w-full mx-auto" id="pricing-table">
                    <div class="pricing-table-header mx-auto w-full stuck rounded-t-none sticky {{stickyHeaderTopClass}}">
                      <div class="pricing-table-row grid w-full auto-cols-min {{bundleStylesColsBig}}">
                        <div class="pricing-table-row-label {{pricingTableRowPackageDissapear}} bg-white"></div>
                        <div class="pricing-table-row-package rounded-t-none text-vis-regular basic-column {{pricingTableRowPackage}}"><strong class="text-vis-regular">{{bundleTitleOne}}</strong></div>
                        <div class="pricing-table-row-package rounded-t-none text-vis-regular {{pricingTableRowPackage}}"  [ngClass]="bundles.length > 2 ? 'deluxe-column': 'premium-column'"><strong class="text-vis-regular">{{bundleTitleTwo}}</strong></div>
                        @if (bundles.length > 2) {
                          <div  class="pricing-table-row-package rounded-t-none text-vis-regular premium-column lg:col-span-2"><strong class="text-vis-regular">{{bundleTitleThree}}</strong></div>
                        }
                      </div>
                    </div>
                    <div class="pricing-table-boddy mx-auto w-full">
                      @for (bpi of bundlePricingItems; track bpi; let last = $last; let index = $index) {
                        <div class="pricing-table-row grid w-full auto-cols-min {{bundleStylesColsBig}}">
                          @if (!bpi.labelHeader) {
                            <div  class="pricing-table-row-label {{pricingTableRowLabel}}">
                              @if (bpi.aceMode && isAceDesign) {
                                <span class="ace-mode-pill bg-ace-mode-linear text-vis-dark">Ace MODE™ Smart Practice</span>
                              }
                              <div class="wysiwyg" [innerHTML]="bpi.principalContent"></div>
                            </div>
                          }
                          @if (bpi.labelHeader) {
                            <div  class="w-full pt-[5px] pb-[5px] border-y border-r bg-vis-teal-2 col-span-9">
                              <div class="wysiwyg capitalize text-left font-extrabold text-white ml-3" [innerHTML]="bpi.principalContent"></div>
                            </div>
                          }
                          @if (!bpi.labelHeader) {
                            <div class="pricing-table-row-package rounded-t-none  {{pricingTableRowPackageTable}}"><span class="icon w-7 h-7 bg-no-repeat bg-center bg-contain inline-block {{bpi.productOne ? (bpi.aceMode && isAceDesign ? 'icon-checked-ace' : 'icon-checked') : 'icon-unchecked'}}"></span></div>
                          }
                          @if (!bpi.labelHeader) {
                            <div class="pricing-table-row-package rounded-t-none {{pricingTableRowPackageTable}}"><span class="icon w-7 h-7 bg-no-repeat bg-center bg-contain inline-block {{bpi.productTwo ? (bpi.aceMode && isAceDesign ? 'icon-checked-ace' : 'icon-checked') : 'icon-unchecked'}}"></span></div>
                          }
                          @if (!bpi.labelHeader && bundles.length >2) {
                            <div class="pricing-table-row-package rounded-t-none {{pricingTableRowPackage}}"><span class="icon w-7 h-7 bg-no-repeat bg-center bg-contain inline-block {{bpi.productThree ? (bpi.aceMode && isAceDesign ? 'icon-checked-ace' : 'icon-checked') : 'icon-unchecked'}}"></span></div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }

                <div
                  id="bundle"
                  class="auto-cols-min  bottom-bundle-container grid justify-items-center desktop-grid grid-cols-3 {{BottomBundleContainerStyles}}"
                  >
                  <div class="bundle-xl-space hidden lg:block {{bundleContainerStylesColSpan}}"></div>
                  @for (b of bundles; track b; let last = $last; let index = $index) {
                    <div
                      class="w-full flex flex-col bundle-product {{pricingTableRowPackageBottom}} bundle-bottom-borders"
                      >
                      <div
                        [ngClass]="bundles.length > 2 ? { 'basic-column': index === 0, 'deluxe-column': index === 1, 'premium-column': index === 2 } : { 'basic-column': index === 0, 'premium-column': index === 1}"
                        class="w-full flex flex-col h-full bg-white text-vis-regular rounded-b-md-bottom bottom-bundle"
                        >
                        <div class="wysiwyg p-v-spacing-bottom-bundle text-vis-regular">
                          <p class="large text-vis-regular"><strong class="text-vis-regular">{{index === 0 ? bundleTitleOne :''}} {{index === 1 ? bundleTitleTwo : ''}} {{index === 2 ? bundleTitleThree : ''}}</strong></p>
                        </div>
                        <div class="flex flex-col h-full">
                          <div class="w-full pt-0 p-v-spacing-bottom-bundle-container pb-3">
                            <div class="flex flex-col">
                              <div class="flex">
                                @if (b.maxPrice && b.savePercentage) {
                                  <span
                                    class="sm:text-lg text-base font-extrabold price-cross-color line-through decoration-vis-dark text-vis-regular mr-1"
                                    >
                                    ${{ b.maxPrice | customNumber : '1.0-0' }}
                                  </span>
                                }
                                @if (b.originalPrice) {
                                  <span #bundlePrice class="sm:text-lg text-base font-extrabold text-vis-teal">
                                    ${{ b.originalPrice | customNumber : '1.0-0' }}
                                  </span>
                                }
                              </div>
                              @if (couponApplied) {
                                <span
                                  class="coupon-applied justify-center mb-3 text-[13px] font-bold text-vis-brand-2 rounded-[30px] py-[7px] px-[15px] bg-[#d9e7f2] w-full md:w-[80%] xl:w-2/3"
                                  >
                                  Coupon Applied!
                                </span>
                              }
                            </div>
                          </div>
                          <div class="w-full pt-0 p-v-spacing-bottom-bundle-buttom items-center">
                            <div class="w-full lg:mr-0 xl:mr-v-spacing bottom-bundle-button-small">
                              <vision-button [data]="getButtonData(b, 'bottom-bundle-small')" [className]="'basic-cta_desktop'"></vision-button>
                            </div>
                            <div class="w-full lg:mr-0 xl:mr-v-spacing bottom-bundle-button">
                              <vision-button [data]="getButtonData(b, 'bottom-bundle')" [className]="'basic-cta_desktop'"></vision-button>
                            </div>
                            <div
                              class="w-full mt-2 text-center text-xs text-vis-subtle pb-3"
                              [class.cursor-pointer]="b.product[0]?.showGuaranteeText"
                              (click)="b.product[0]?.showGuaranteeText && activateModal()"
                              >
                              @if (b.product[0] && !suppressGuarantee(b.product[0])) {
                                <span class="inline-block">
                                  {{ b.product[0].showGuaranteeText ? guaranteeText : '' }}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <!-- End Desktop View -->
              </div>
              @if (hasBnplEligibleProducts) {
                <div class="bnpl-disclaimer mt-12">
                  <div class="flex">
                    <div class="bullet">†</div>
                    <div>
                      <p>
                        Payment options are offered by Affirm and are subject to an eligibility check. Options depend on your
                        purchase amount, and a down payment may be required. CA residents: Loans by Affirm Loan Services, LLC are
                        made or arranged pursuant to a California Finance Lender license. For licenses and disclosures, see
                        <a target="_blank" href="https://www.affirm.com/licenses">affirm.com/licenses</a>.
                      </p>
                    </div>
                  </div>
                  <div class="flex">
                    <div class="bullet">††</div>
                    <div>
                      <p>
                        See Klarna payment
                        <a href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx" target="_blank">terms</a
                          >. A higher initial payment may be required for some consumers. CA resident loans made or arranged pursuant
                          to a California Financing Law license.
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
